  jQuery(document).ready(function($){

    // ===== Made to Measure (medida personalizada cobrada por m²) =====
    (function initMadeToMeasure(){
      var $mtm = $('#made-to-measure');
      if (!$mtm.length) return;

      var unitsPerArea = parseInt($mtm.data('units-per-area'), 10) || 1; // frações de unidade² por unidade de preço
      var unitPriceCents = parseInt($mtm.data('unit-price'), 10) || 0;   // preço da variante "custom" (subunidade)
      var minSide = parseFloat($mtm.data('min-side')) || 0;              // medida mínima por lado
      var maxSide = parseFloat($mtm.data('max-side'));                   // medida máxima por lado; NaN = sem limite
      var customVariantId = String($mtm.data('custom-variant-id') || ''); // ID da variante "custom"
      var formId = String($mtm.data('form-id') || '');
      var unit = String($mtm.data('unit') || 'ft');                     // unidade de medida (ex.: ft)
      var currency = String($mtm.data('currency') || 'USD');            // moeda-base da loja (p/ casas decimais)
      var moneyFormat = String($mtm.data('money-format') || '${{amount}}'); // formato de moeda do tema (shop.money_format)
      var locale = String($mtm.data('locale') || '') || undefined;      // locale para formatação de números
      var msgRequired = String($mtm.data('msg-required') || '');        // mensagens vindas das traduções
      var msgMin = String($mtm.data('msg-min') || '');
      var msgMax = String($mtm.data('msg-max') || '');

      var $width  = $mtm.find('.measure-input--width');
      var $length = $mtm.find('.measure-input--length');
      var $area   = $mtm.find('.measure-area-input');
      var $uid    = $mtm.find('.measure-uid-input');
      var $customInputs = $width.add($length).add($area).add($uid);

      // Valor único por adição — impede a fusão de linhas sob medida idênticas.
      function newUid(){
        return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      }

      var $areaValue    = $mtm.find('.measure-area-value');
      var $totalValue   = $mtm.find('.measure-total-value');
      var $summary      = $mtm.find('.measure-summary');
      var $chargedRow   = $mtm.find('.measure-charged-row');
      var $chargedValue = $mtm.find('.measure-charged-value');

      // A variante "custom" fica escondida no seletor de tamanho; localizamos por valor.
      var $customVariant = $('.variant-picker input[type="radio"]').filter(function(){
        return ($(this).val() || '').toLowerCase() === 'custom';
      }).first();
      var $sizeFieldset  = $customVariant.closest('fieldset');
      var $qtyInput = $('.product-details quantity-selector-component input[name="quantity"]');
      // Input escondido "id" do formulário de compra (a variante realmente enviada ao carrinho).
      var $idInput = $('#' + formId + ' input[name="id"]');

      function isCustomActive(){ return $('body').hasClass('mtm-custom-active'); }

      // Garante que a variante enviada seja a "custom", independentemente do pipeline
      // assíncrono do seletor de variantes.
      function forceCustomId(){
        if (customVariantId && $idInput.length) { $idInput.val(customVariantId); }
      }

      $mtm.find('.measure-input').mask('000.00', { reverse: true });

      function parseNum(v){
        v = (v || '').toString().replace(',', '.');
        var n = parseFloat(v);
        return isNaN(n) ? 0 : n;
      }

      // Formata dinheiro exatamente como o filtro `money` do tema (mesmo símbolo/separadores),
      // portado de assets/money-formatting.js. Assim o total combina com os demais preços.
      var CURRENCY_DECIMALS = {
        BHD: 3, IQD: 3, JOD: 3, KWD: 3, LYD: 3, OMR: 3, TND: 3,
        BIF: 0, BYR: 0, CLP: 0, DJF: 0, GNF: 0, ISK: 0, JPY: 0, KMF: 0, KRW: 0,
        PYG: 0, RWF: 0, UGX: 0, VND: 0, VUV: 0, XAF: 0, XOF: 0, XPF: 0
      };
      function currencyPrecision(c){
        var key = (c || '').toUpperCase();
        return CURRENCY_DECIMALS[key] != null ? CURRENCY_DECIMALS[key] : 2;
      }
      function formatCents(value, thousands, decimal, precision, divisor){
        var rounded = (value / divisor).toFixed(precision);
        var arr = rounded.split('.');
        var a = arr[0] || '0';
        var b = arr[1] || '';
        a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, function(d){ return d + thousands; });
        return precision <= 0 ? a : a + decimal + b;
      }
      function formatMoney(cents){
        var precision = currencyPrecision(currency);
        var divisor = Math.pow(10, precision);
        return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, ph){
          if (ph === 'currency') return currency;
          var thousands = ',', decimal = '.', p = precision;
          switch (ph) {
            case 'amount_no_decimals': p = 0; break;
            case 'amount_with_comma_separator': thousands = '.'; decimal = ','; break;
            case 'amount_no_decimals_with_comma_separator': thousands = '.'; p = 0; break;
            case 'amount_no_decimals_with_space_separator': thousands = ' '; p = 0; break;
            case 'amount_with_space_separator': thousands = ' '; decimal = ','; break;
            case 'amount_with_period_and_space_separator': thousands = ' '; decimal = '.'; break;
            case 'amount_with_apostrophe_separator': thousands = "'"; decimal = '.'; break;
          }
          return formatCents(cents, thousands, decimal, p, divisor);
        });
      }
      function formatNum(n){
        try { return n.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
        catch (e) { return n.toFixed(2); }
      }
      function areaText(n){ return formatNum(n) + ' ' + unit + '²'; }

      function recalc(){
        var w = parseNum($width.val());
        var l = parseNum($length.val());
        var area = w * l;
        var invalid = '';
        var hasMax = !isNaN(maxSide) && maxSide > 0;

        if (w <= 0 || l <= 0) {
          invalid = msgRequired;
        } else if (minSide > 0 && (w < minSide || l < minSide)) {
          invalid = msgMin;
        } else if (hasMax && (w > maxSide || l > maxSide)) {
          invalid = msgMax;
        }

        // Bloqueia o "Adicionar ao carrinho" enquanto as medidas forem inválidas.
        if ($width.length) { $width[0].setCustomValidity(invalid); }

        if (!invalid) {
          var qty = Math.max(1, Math.round(area * unitsPerArea));
          var chargedArea = qty / unitsPerArea;
          $qtyInput.val(qty);
          $area.val(area.toFixed(2));
          $areaValue.text(areaText(area));
          // Se a área cobrada difere da área real (modo "unidade² inteira"), deixa isso explícito.
          if (Math.abs(chargedArea - area) > 0.01) {
            $chargedValue.text(areaText(chargedArea));
            $chargedRow.prop('hidden', false);
          } else {
            $chargedRow.prop('hidden', true);
          }
          $totalValue.text(formatMoney(qty * unitPriceCents));
          $summary.prop('hidden', false);
          forceCustomId();
        } else {
          $qtyInput.val(1);
          $area.val('');
          $summary.prop('hidden', true);
        }
      }

      function selectCustom(){
        if ($customVariant.length) { $customVariant.prop('checked', false).click(); }
      }

      function selectFirstStandard(){
        var $std = $sizeFieldset
          .find('label[data-available="true"]')
          .filter(function(){
            return ($(this).find('input').val() || '').toLowerCase() !== 'custom';
          })
          .first()
          .find('input');
        if ($std.length) { $std.click(); }
      }

      function openCustom(){
        $('.form-toggle').addClass('active');
        $('#measure-form').slideDown(400);
        $('body').addClass('mtm-custom-active');
        $customInputs.prop('disabled', false);
        $width.add($length).prop('required', true);
        $uid.val(newUid());
        selectCustom();
        forceCustomId();
        recalc();
      }

      function closeCustom(){
        $('.form-toggle').removeClass('active');
        $('#measure-form').slideUp(400);
        $('body').removeClass('mtm-custom-active');
        if ($width.length) { $width[0].setCustomValidity(''); }
        $width.add($length).prop('required', false);
        $customInputs.prop('disabled', true);
        $qtyInput.val(1);
        selectFirstStandard();
      }

      $mtm.find('.measure-input').on('input blur', recalc);

      $('.form-toggle').on('click', function(e){
        e.preventDefault();
        if ($(this).hasClass('active')) { closeCustom(); } else { openCustom(); }
      });

      // Rede de segurança: no exato momento do envio, se a personalização estiver ativa,
      // reforça o ID da variante "custom" antes do FormData ser lido (fase de captura).
      var formEl = document.getElementById(formId);
      if (formEl) {
        formEl.addEventListener('submit', function(){
          if (isCustomActive()) {
            forceCustomId();
            // Novo identificador a cada envio: garante linha separada mesmo ao
            // adicionar duas vezes as mesmas medidas sem reabrir o formulário.
            $uid.val(newUid());
          }
        }, true);
      }

      // Se a variante "custom" já vier selecionada ao carregar a página, abre o formulário.
      if ($customVariant.length && $customVariant.is(':checked')) {
        openCustom();
      }
    })();

    $('.tabs ul li').on('click', function(e){
      
      e.preventDefault();
      let target = $(this).data('target');

      $('.tabs ul li').removeClass('active');
      $(this).addClass('active');
      
      $('.tab-content').removeClass('active');
      $(`.tab-content[data-target="${target}"]`).addClass('active');

    });

    var desktopSlideClickBlocked = false;

    $(document).on('mousedown', '.desktop-slide-horizontal', function(e) {
      if (e.button !== 0 || window.matchMedia('(max-width: 990px)').matches) return;

      var slide = this;

      if (slide.scrollWidth <= slide.clientWidth) return;

      var startX = e.pageX;
      var startScrollLeft = slide.scrollLeft;
      var hasMoved = false;

      slide.classList.add('is-dragging');
      e.preventDefault();

      function onMouseMove(event) {
        var distance = event.pageX - startX;

        if (Math.abs(distance) > 5) {
          hasMoved = true;
          desktopSlideClickBlocked = true;
        }

        slide.scrollLeft = startScrollLeft - distance;
        event.preventDefault();
      }

      function onMouseUp() {
        slide.classList.remove('is-dragging');
        $(document).off('mousemove.desktopSlideDrag', onMouseMove);
        $(document).off('mouseup.desktopSlideDrag', onMouseUp);

        if (hasMoved) {
          window.setTimeout(function() {
            desktopSlideClickBlocked = false;
          }, 0);
        }
      }

      $(document).on('mousemove.desktopSlideDrag', onMouseMove);
      $(document).on('mouseup.desktopSlideDrag', onMouseUp);
    });

    document.addEventListener('click', function(event) {
      if (!desktopSlideClickBlocked || !event.target.closest('.desktop-slide-horizontal')) return;

      event.preventDefault();
      event.stopPropagation();
      desktopSlideClickBlocked = false;
    }, true);

    initSliders();

    // Função para sincronizar
    function syncPosition(event, $thumbs) {
      var index = (event && event.item && typeof event.item.index === 'number') ? event.item.index : 0;
      $thumbs
        .find(".owl-item")
        .removeClass("current active")
        .eq(index)
        .addClass("current active");
      $thumbs.trigger("to.owl.carousel", [index, 300, true]);
    }

    function initSliders(scope){
        var $scope = scope ? $(scope) : $(document);

        $scope.find(".product-card__content").addBack(".product-card__content").each(function() {
          var $wrapper = $(this); // escopo do wrapper atual
          var $main = $wrapper.find(".card-carousel");
          var $thumbs = $wrapper.find(".thumbs-controller");

          function safeInitOwl($el, options) {
            if (!$el || !$el.length) return;
            // If already initialized, destroy first to avoid nested markup and broken states
            if ($el.data('owl.carousel')) {
              $el.trigger('destroy.owl.carousel');
              $el.removeClass('owl-loaded owl-hidden owl-refresh owl-drag owl-grab');
            }
            $el.owlCarousel(options);
          }

          if ($main && $main.length) {
            $main.off('changed.owl.carousel').on("changed.owl.carousel", function(event) {
              if ($thumbs && $thumbs.length) {
                syncPosition(event, $thumbs);
              }
            });

            // Carrossel principal
            safeInitOwl($main, {
              items: 1,
              margin: 0,
              loop: false,
              nav: false,
              dots: false,
              autoplay: false,
              mouseDrag: false,
              touchDrag: false,
              pullDrag: false,
            });
          }

          // Carrossel de thumbs
          if ($thumbs && $thumbs.length) {
            $thumbs
              .off('initialized.owl.carousel click')
              .on("initialized.owl.carousel", function() {
                $(this).find(".owl-item").removeClass("current active").eq(0).addClass("current active");
              })
              .on("click", ".owl-item", function(e) {
                e.preventDefault();
                var index = $(this).index();
                $thumbs.find(".owl-item").removeClass("current active");
                $(this).addClass("current active");
                $main.trigger("to.owl.carousel", [index, 300, true]);
              });

            safeInitOwl($thumbs, {
              items: 3,
              margin: 10,
              loop: false,
              nav: false,
              dots: false,
              autoplay: false,
              mouseDrag: false,
              touchDrag: false,
              pullDrag: false
            });
          }

          // Garantia extra caso o evento initialized não dispare (edge cases)
          window.setTimeout(function() {
            if ($thumbs && $thumbs.length) {
              $thumbs.find(".owl-item").removeClass("current active").eq(0).addClass("current active");
            }
          }, 0);
      });
    }

    var initSlidersTimer;
    function scheduleInitSliders(scope) {
      window.clearTimeout(initSlidersTimer);
      initSlidersTimer = window.setTimeout(function() {
        initSliders(scope);
      }, 50);
    }

    $('input[name="grid-mobile"]').on('click',function(e){
      scheduleInitSliders();
    });

    document.addEventListener('shopify:section:load', function(event) {
      scheduleInitSliders(event.target);
    });

    var productGridObserver = new MutationObserver(function(mutations) {
      var shouldInit = mutations.some(function(mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function(node) {
          return node.nodeType === 1 && (
            node.matches && node.matches('.product-card__content, .card-carousel, .thumbs-controller') ||
            node.querySelector && node.querySelector('.product-card__content, .card-carousel, .thumbs-controller')
          );
        });
      });

      if (shouldInit) {
        scheduleInitSliders();
      }
    });

    productGridObserver.observe(document.body, { childList: true, subtree: true });

  });